export const ORDER_NEW = "NEW";
export const ORDER_CONFIRMED = "CONFIRMED";
export const ORDER_CANCELLED = "CANCELLED";
export const ORDER_DELIVERED = "DELIVERED";
export const ORDER_CHANGE_REQUESTED = "ORDER_CHANGE_REQUESTED";
export const ORDER_DENIED = "DENIED";
